import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import { connect } from 'react-redux';
import { compose } from 'redux';

import { ActionCreators } from 'utils/redux-undo';
import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { blank } from 'spiceutils';

import { replaceHistoryState } from 'utils/history';
import history from 'utils/history/historyObject';

import CodebookModal from 'containers/CodebookModal';
import QuestionSelector from 'containers/QuestionSelector';

import AnimatedLoader from '../../components/AnimatedLoader/fullScreen';

import saga from '../App/saga';
import reducer from '../App/reducer';
import {
  makeSelectCDF,
  makeSelectControlList,
  makeSelectClientPackage,
  makeSelectShowNewQuestionSelector,
  makeSelectRole,
  makeSelectPageLoading,
} from '../App/selectors';

import { updateCDF, isAuthenticated, getPackage, getUser } from '../App/actions';
import { AUTHORISED_ROLES } from '../App/constants';

import DatatoolSlim from '../DatatoolSlim';
import DatatoolAdvanced from '../DatatoolAdvanced';

import UnauthorizedPopup from '../../components/UnauthorizedPopup';
import JWTErrorPopup from '../../components/JWTErrorPopup';

const theme = require('sass-extract-loader?{"plugins": ["sass-extract-js"]}!../../vars.scss');

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    this.navigationListener = this.navigationListener.bind(this);
    this.navigationKeys = [undefined];
  }

  componentWillMount() {
    const {
      isAuthenticated,
      getPackage,
      getUser,

      location: { pathname },
    } = this.props;
    // This will run once on load, so we send an IS_AUTHENTICATED action and SET_PACKAGE
    isAuthenticated(pathname);
    getPackage();
    getUser();

    this.attachNavigationListener();
    replaceHistoryState();
  }

  componentWillUnmount() {
    if (this.detachNavigationListener) {
      this.detachNavigationListener();
    }
  }

  attachNavigationListener() {
    this.detachNavigationListener = history.listen(this.navigationListener);
  }

  navigationListener(location, eventType) {
    const { goBack, goForward } = this.props;
    if (eventType === 'POP') {
      if (location.key === this.navigationKeys.slice(-2)[0]) {
        goBack();
        this.navigationKeys.splice(-1, 1);
      } else {
        goForward();
        this.navigationKeys.push(location.key);
      }
    } else if (eventType === 'PUSH') {
      this.navigationKeys.push(location.key);
    } else if (eventType === 'REPLACE') {
      this.navigationKeys.splice(-1, 1, location.key);
    }
  }

  render() {
    const {
      cdf,
      role,
      clientPackage,
      location: { pathname },
      controlList,
      showNewQuestionModal,
      updateCDF,
      pageLoading,
    } = this.props;

    // If role has been set from GQL
    const loaded = role !== null && !pageLoading;
    // If we are not logged in, show the unauthorized modal
    const authorized = role !== null && AUTHORISED_ROLES.includes(role);
    // If there was an error accessing the JWT, load error modal
    const jwtError = loaded && role === 'auth_error';
    // the QuestionSelector
    const shouldShowNewQuestionModal = ((cdf.QuestionCode === undefined || blank(controlList))) || showNewQuestionModal === true;
    const isAdvanced = pathname === '/advanced';

    let datatool = null;
    if (isAdvanced) {
      // Are we visiting the slim tool or the advanced tool?
      datatool = (
        <DatatoolAdvanced
          cdf={cdf}
          controlList={controlList}
          clientPackage={clientPackage}
          updateCDF={updateCDF}
        />
      );
    } else {
      datatool = (
        <DatatoolSlim
          cdf={cdf}
          controlList={controlList}
          clientPackage={clientPackage}
          updateCDF={updateCDF}
        />
      );
    }

    return (
      <ThemeProvider theme={theme}>
        <div>
          {!loaded &&
            <AnimatedLoader />
          }
          {loaded && jwtError &&
            <JWTErrorPopup />
          }
          {loaded && !authorized && !jwtError &&
            <UnauthorizedPopup />
          }
          {datatool}
          {authorized && shouldShowNewQuestionModal && isAdvanced &&
            // Advanced mode
            <QuestionSelector
              cdf={cdf}
              clientPackage={clientPackage}
            />
          }
          {authorized && !isAdvanced &&
            // Standard mode
            <CodebookModal
              foreground={shouldShowNewQuestionModal}
            />
          }
        </div>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  cdf: makeSelectCDF(),
  controlList: makeSelectControlList(),
  clientPackage: makeSelectClientPackage(),
  showNewQuestionModal: makeSelectShowNewQuestionSelector(),
  role: makeSelectRole(),
  pageLoading: makeSelectPageLoading(),
});

export function mapDispatchToProps(dispatch) {
  return {
    updateCDF: (field, value) => {
      dispatch(updateCDF(field, value));
    },
    goBack: () => {
      dispatch(ActionCreators.undo());
    },
    goForward: () => {
      dispatch(ActionCreators.redo());
    },
    isAuthenticated: (path) => {
      dispatch(isAuthenticated(path));
    },
    getPackage: () => {
      dispatch(getPackage());
    },
    getUser: () => {
      dispatch(getUser());
    },
  };
}

HomePage.propTypes = {
  cdf: PropTypes.object,
  controlList: PropTypes.object,
  showNewQuestionModal: PropTypes.bool,
  updateCDF: PropTypes.func,
  clientPackage: PropTypes.string,
  location: PropTypes.object,
  isAuthenticated: PropTypes.func,
  getPackage: PropTypes.func,
  getUser: PropTypes.func,
  role: PropTypes.string,
  goBack: PropTypes.func.isRequired,
  goForward: PropTypes.func.isRequired,
  pageLoading: PropTypes.bool,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({ key: 'home', reducer });
const withSaga = injectSaga({ key: 'home', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(HomePage);



// WEBPACK FOOTER //
// ./app/containers/HomePage/index.js